module.exports = __webpack_public_path__ + "img/bmcl_gallery13.498f3c59.jpg";